import {
    getGoodsFissionRules,
    goodsFissionAddRule,
    goodsFissionUpdateRule,
    goodsFissionDeleteRule,
    getGoodsFissionRuleDetail,
    goodsFissionPreView,
    goodsPreViewInfoEdit,
    aiGenerateTitle,
    goodsFissionConfig,
} from '@api/prod/goodsFissionRule.js';

export const getGoodsFissionRulesApi = (data) => {
  return getGoodsFissionRules(data).then((res) => {
      if (res.result === 1) {
          return res.data;
      }
      return false;
  })
}
export const getGoodsFissionAddRuleApi = (data) => {
  return goodsFissionAddRule(data).then((res) => {
      if (res.result === 1) {
          return true;
      }
      return false;
  })
}
export const goodsFissionUpdateRuleApi = (data) => {
  return goodsFissionUpdateRule(data).then((res) => {
      if (res.result === 1) {
          return true;
      }
      return false;
  })
}
export const goodsFissionDeleteRuleApi = (data) => {
  return goodsFissionDeleteRule(data).then((res) => {
      if (res.result === 1) {
          return true;
      }
      return false;
  })
}
export const getGoodsFissionRuleDetailApi = (data) => {
  return getGoodsFissionRuleDetail(data).then((res) => {
      if (res.result === 1) {
          return res.data;
      }
      return false;
  })
}
export const goodsFissionPreViewApi = (data) => {
  return goodsFissionPreView(data).then((res) => {
      if (res.result === 1) {
          return res.data;
      }
      return false;
  })
}
export const goodsPreViewInfoEditApi = (data) => {
  return goodsPreViewInfoEdit(data).then((res) => {
      if (res.result === 1) {
          return true;
      }
      return false;
  })
}
export const aiGenerateTitleApi = (data) => {
  return aiGenerateTitle(data).then((res) => {
      if (res.result === 1) {
          return res.data;
      }
      return false;
  })
}
export const goodsFissionConfigApi = (data) => {
  return goodsFissionConfig(data).then((res) => {
      if (res.result === 1) {
          return res.data;
      }
      return false;
  })
}